'use client';

import { useIntl } from 'react-intl';
import { Card, CardContent, CardHeader } from '@packages/shared/src/ui/Card/Card';
import type { RatingsOverviewProps } from '../RatingsOverview/RatingsOverview';
import { RatingsOverview } from '../RatingsOverview/RatingsOverview';
import { RatingsOverviewCardMessages } from './RatingsOverviewCard.messages';

export type RatingsOverviewCardProps = Pick<RatingsOverviewProps, 'data'>;

/**
 * The RatingsOverviewCard component displays the ratings overview in a card
 */
export const RatingsOverviewCard = ({ data, ...props }: RatingsOverviewCardProps) => {
  const { formatMessage } = useIntl();

  return (
    <div {...props}>
      <Card>
        <CardHeader hasDivider>{formatMessage(RatingsOverviewCardMessages.header)}</CardHeader>
        <CardContent className="py-2">
          <RatingsOverview data={data} />
        </CardContent>
      </Card>
    </div>
  );
};
